import React from 'react';
import l1 from '../../assets/img/service/l1.png';
import l2 from '../../assets/img/service/l2.png';
import l3 from '../../assets/img/service/l3.png';
import l4 from '../../assets/img/service/l4.png';
import l5 from '../../assets/img/service/l5.png';

const Development = () => {
  const lodLevels = [
    { title: "LOD 100", subtitle: "(Conceptualization)", img: l1 },
    { title: "LOD 200", subtitle: "(Schematic Design)", img: l2 },
    { title: "LOD 300", subtitle: "(Detailed Design)", img: l3 },
    { title: "LOD 400", subtitle: "(Fabrication & Assembly)", img: l4 },
    { title: "LOD 500", subtitle: "(As-built Conditions)", img: l5 },
  ];

  return (
    <section className="development-section">
      {/* Top Part: LOD Levels */}
      <div className="lod-container">
        <h2 className="section-title">
          <span className="text-primary">BIM LOD 100 to 500</span> Level of Development
        </h2>
        <p className="section-subtitle">
          BIM Level of Development (LOD 100 to 500) are standard that specifies the detail of information in the BIM 3D model.
          These are standards from conceptualization to as-built for facility management.
        </p>

        <div className="lod-grid">
          {lodLevels.map((lod, index) => (
            <div key={index} className="lod-card">
              <div className="lod-image-box">
                {lod.img ? (
                  <img src={lod.img.src || lod.img} alt={lod.title} />
                ) : (
                  <div className="lod-placeholder-icon"></div>
                )}
              </div>
              <div className="lod-info">
                <h3>{lod.title}</h3>
                <span>{lod.subtitle}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Development;
